import { type CardsModel } from '../../types'
import { type TCards } from '../../../redux/types/CardsTypes'

const mapCards = (cards: TCards[] | undefined): CardsModel[] | undefined => {
  return cards?.map((card: any) => {
    const limit = (card.total_limit + '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    const dailyLimit = (card.daily_total_limit + '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    const monthlyLimit = (card.monthly_total_limit + '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    return { ...card, total_limit: limit, daily_total_limit: dailyLimit, monthly_total_limit: monthlyLimit }
  })
}

export default mapCards
